import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUIToastConfig } from './toast-config';
import { CoreUIIconsModule } from '../icons/core-ui-icons.module'
import { CoreUIToastComponent } from './core-ui-toast.component';
import { CoreUiLoaderModule } from '../loader/core-ui-inputs.module';

@NgModule({
  declarations: [
    CoreUIToastComponent
  ],
  imports: [
    CommonModule,
    CoreUIIconsModule,
    CoreUiLoaderModule
  ],
  exports: [
    CoreUIToastComponent
  ],
  providers: [CoreUIToastConfig],
})
export class CoreUIToastsV2Module {}
